export default __webpack_public_path__ + "static/media/Comp 2_00008.0c88aa8b.png";